import RichtextAdapter from "modules/storyblok/adapters/RichtextAdapter";
import { contentStyles } from "./CardBody.styles";
import type { CardBodyProps } from "./CardBody.d";

export const CardBody = ({ reviewText }: CardBodyProps) =>
  reviewText && <RichtextAdapter content={reviewText} customStyles={contentStyles} />;
